enum UserHomeCustomContentKey
{
    None = 0,
    Aon = 1
}

export default UserHomeCustomContentKey;
